// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._m5ny16oo #profile-card-trigger-popup-wrapper{z-index:510}", ""]);
// Exports
module.exports = exports;
